import { KeyValue } from "@angular/common";
import { Pipe, type PipeTransform } from "@angular/core";

@Pipe({
    name: "appEnumKeyValue",
    standalone: true,
})
export class EnumKeyValuePipe implements PipeTransform {
    transform(value: Record<string, string | number>): KeyValue<string, string | number>[] {
        return Object.entries(value)
            .filter((key) => !isNaN(Number(value[key[0] as keyof typeof value])))
            .map((key) => ({ key: key[0], value: key[1] }));
    }
}
